const Mn = require('backbone.marionette');
const Template = require('common/ui/template/project_error.hbs');
const i18n = require('i18next');
const CoverView = require('balus/ui/view/body/project/cover');

module.exports = Mn.View.extend({
    template: Template,

    regions: {
        cover: '#cover'
    },

    username: function() {
        const user = this.getOption('user');
        return user.get('name');
    },

    userImage: function() {
        const user = this.getOption('user');
        return user.get('image_url');
    },

    currentUserMessage: function() {
        return i18n.t('error:error_page.permission_error.current_user');
    },

    serializeData: function() {
        const isPermissionError = this.getOption('statusCode') == 403;
        const model = this.getOption('model');
        const path = model.path();

        return {
            title: this.getOption('title'),
            info: this.getOption('info'),
            path: path,
            isPermissionError: isPermissionError,
            username: this.username(),
            userImage: this.userImage(),
            currentUserMessage: this.currentUserMessage()
        }
    },

    onRender: function() {
        if (this.getOption('activeTab') == 'process') {
            this.showChildView('cover', new CoverView({
                model: this.getOption('model'),
                context: this.getOption('context'),
                process: true,
                hideNavToggle: true
            }));
        }
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/project_error.js